import { useEffect, useState } from "react";
import socket from "../utils/Socket";

export function useOwnOrderBook(symbol) {
    const [orderBook, setOrderBook] = useState({

        bids: [],
        asks: [],
        symbol: "",
        buyRatio: "0.00",
        sellRatio: "0.00",
    });

    useEffect(() => {
        if (!symbol) return;

        const normalizedSymbol = symbol.toUpperCase();
        const eventName = `order_book_${normalizedSymbol}`;

        socket.emit("joinOrderBook", normalizedSymbol);

        socket.on(eventName, (data) => {
            // 🔥 DO NOT MERGE / GROUP HERE
            setOrderBook({
                bids: data.bids || [],
                asks: data.asks || [],
                symbol: data.symbol,
                buyRatio: data.buyRatio ?? "0.00",
                sellRatio: data.sellRatio ?? "0.00",
            });
        });

        return () => {
            socket.emit("leaveOrderBook", normalizedSymbol);
            socket.off(eventName);
        };
    }, [symbol]);

    return orderBook;
}
